import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import { SaveCategoriaIncidente } from '../../shared/components/SaveCategoriaIncidente';





export interface CrearCategoriaIncidentePageInterface {}

const CrearCategoriaIncidentePage: React.FC<CrearCategoriaIncidentePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_categoria_producto)
  return <SaveCategoriaIncidente titlePage="Crear Categoria Incidencia" />;
};

export default CrearCategoriaIncidentePage;
